import { z } from 'zod';
import { Paginated } from '../../common/pagination.js';
import { FileReportInput, ModerateInput, ReportContext, ReportQueueQuery, ReportView, SanctionView, } from './schemas.js';
export const adminModerationRoutes = {
    reports: {
        method: 'GET',
        path: '/admin/reports',
        query: ReportQueueQuery,
        response: Paginated(ReportView),
    },
    reportContext: {
        method: 'GET',
        path: '/admin/reports/:reportId/context',
        response: ReportContext,
    },
    claimReport: { method: 'POST', path: '/admin/reports/:reportId/claim', response: ReportView },
    moderate: {
        method: 'POST',
        path: '/admin/reports/:reportId/moderate',
        body: ModerateInput,
        response: ReportView,
    },
    sanction: { method: 'GET', path: '/admin/members/:userId/sanction', response: SanctionView },
};
/** Member-side report filing (FR-ENGA-08 "Report", FR-NET-11) — lives in the public manifest. */
export const memberReportRoute = {
    method: 'POST',
    path: '/reports',
    body: FileReportInput,
    response: z.object({ id: z.string() }),
};
//# sourceMappingURL=routes.js.map